<div class="page-wrapper">
<app-spinner></app-spinner>
<router-outlet></router-outlet>
</div>
